import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

export const SiteShell = ({ children, testId = "site-shell" }) => (
  <div data-testid={testId} className="flex min-h-screen flex-col bg-white">
    <SiteHeader />
    <main className="flex-1">{children}</main>
    <SiteFooter />
  </div>
);
